"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAllLocationsByZipService = void 0;
const utils_1 = require("@hc-frontend/utils");
const __1 = require("..");
/**
 * Fetch all possible locations that match the `zip` code
 *
 * @public
 *
 * @param zip The zip code to be fetched
 *
 * @returns The array of possible locations related with the zip, otherwise an empty array will be returned
 *
 * @example
 * ```ts
 * const locations = await fetchAllLocationsByZipService('3133');
 * ```
 */
async function fetchAllLocationsByZipService(zip) {
    const url = `${(0, __1.geoLocationURI)()}/GeoLocation/${zip}`;
    const { parsedBody } = await (0, utils_1.fetchJSON)(url);
    return (0, utils_1.isArray)(parsedBody) ? parsedBody : null;
}
exports.fetchAllLocationsByZipService = fetchAllLocationsByZipService;
//# sourceMappingURL=fetch-all-locations-by-zip-service.js.map